import { render, staticRenderFns } from "./LegoQuill.vue?vue&type=template&id=4d3471f8&scoped=true"
import script from "./LegoQuill.vue?vue&type=script&lang=js"
export * from "./LegoQuill.vue?vue&type=script&lang=js"
import style0 from "./LegoQuill.vue?vue&type=style&index=0&id=4d3471f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d3471f8",
  null
  
)

export default component.exports